<div class="andromeda-search-bar" [formGroup]="parentForm">
  <div class="andromeda-search-bar-icon">
    <lib-icon-injector
      iconClass="search-icon"
      pathToIcon="assets/icons/search.svg"
    ></lib-icon-injector>
  </div>
  <input
    #input
    class="andromeda-search-input"
    [placeholder]="placeholderValue"
    formControlName="{{ formControlName }}"
    (input)="onInputChange($event)"
  />
</div>
